import { useRecoilState, useResetRecoilState } from "recoil";
import { redirectState } from "./atom";

/**
 * redirectUrl 안전한 사용을 위한 커스텀 훅
 * sessionStorage도 함께 관리
 */
export const useRedirectUrl = () => {
  const [redirectUrl, setRedirectUrl] = useRecoilState(redirectState);
  const resetRedirectState = useResetRecoilState(redirectState);
  const clearRedirectUrl = () => {
    setRedirectUrl("");
    resetRedirectState();
  };

  return {
    redirectUrl,
    setRedirectUrl,
    clearRedirectUrl,
  };
};
